import { ProjCard } from "../project-card.component";

export const Projects = () => {
  return (
    <section
      className="min-h-screen relative flex flex-col items-start w-full bg-slate-950 z-20"
      id="projects"
    >
      <h1
        className="py-20 px-10 text-white text-center main_titles"
        data-aos="fade-right"
      >
        Projects
      </h1>

      <div className="wrapper flex justify-center w-full h-full">
        <ul className="flex flex-col items-center md:grid md:grid-cols-2 xl:grid-cols-4 lg:items-start gap-3 w-full px-4">
          <li
            className="flex md:col-span-2 lg:row-span-2 h-full"
            data-aos="zoom-in-down"
            data-aos-duration="800"
          >
            <ProjCard
              title="Marketplace OTP2P"
              howManyImgs={7}
              description="A marketplace for buying and selling accounts, skins and items for games. I developed the frontend of this project using Angular, creating a responsive and user-friendly interface that allows users to easily navigate through the platform and manage their transactions."
              img="otp2p"
              url=""
              stacks={["Angular", "Typescript", "NodeJS", "Express", "MongoDB"]}
              repo="https://github.com/Sr-Van/otp2p-frontend"
              isPrimary={true}
            />
          </li>

          <li
            data-aos="fade-down"
            data-aos-delay="700"
            data-aos-easing="ease-out"
            data-aos-duration="1000"
            className="h-full"
          >
            <ProjCard
              title="E-commerce Val"
              howManyImgs={4}
              description="An e-commerce for a small store with various items and clothing."
              img="valmaga"
              stacks={["Angular", "Typescript", "Git", "Bootstrap"]}
              url="https://valmagazine.netlify.app/products"
              repo="https://github.com/Sr-Van/e-commerce-val"
            />
          </li>

          <li
            data-aos="fade-down"
            data-aos-duration="1000"
            data-aos-easing="ease-out"
            data-aos-delay="700"
            className="h-full"
          >
            <ProjCard
              title="Technical Test"
              howManyImgs={4}
              description="A showcase to test my knowledge on Angular to an interview."
              img="teste"
              stacks={["Angular", "Typescript", "Git", "HTML5", "CSS3"]}
              url="https://teste-tecnico-nextgen.netlify.app/home"
              repo="https://github.com/Sr-Van/teste-tecnico-front-end-VandersonErlan"
            />
          </li>
          <li
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-easing="ease-out"
            data-aos-delay="700"
            className="h-full"
          >
            <ProjCard
              title="E-mail Analyzer"
              howManyImgs={4}
              description="A smart e-mail analyzer that uses the Google Gemini API to extract insights and perform analyses on PDF and TXT files."
              img="analyzer"
              stacks={[
                "Python",
                "Flask",
                "Google Gemini",
                "Typescript",
                "Git",
                "HTML5",
                "Tailwind CSS",
              ]}
              url="https://projeto-ia-monorepo.vercel.app/"
              repo="https://github.com/Sr-Van/projeto-ia-monorepo"
            />
          </li>
          <li
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-easing="ease-out"
            data-aos-delay="700"
            className="h-full"
          >
            <ProjCard
              title="Dashboard Internet"
              howManyImgs={6}
              description="A dashboard to control your internet provider. Make from scretch with only Js, HTML5 and CSS3."
              img="srvsys"
              stacks={["Javascript", "Git", "HTML5", "CSS3"]}
              url="https://srv-system.netlify.app/index.html"
              repo="https://github.com/Sr-Van/srv-system"
            />
          </li>
        </ul>
      </div>

      <div
        data-aos="zoom-in"
        data-aos-delay="700"
        className="absolute hidden md:block -top-10 right-4 -rotate-45"
      >
        <div className="parallax_css w-40 h-40 bg-gradient-to-r from-slate-800 to-indigo-900 rounded-full relative">
          <div
            data-aos="fade-left"
            data-aos-delay="800"
            className="w-8 h-8 rounded-full bg-purple-500 absolute bottom-3 right-12"
          ></div>
          <div
            data-aos="fade-left"
            data-aos-delay="900"
            className="w-7 h-7 rounded-full bg-yellow-500 absolute bottom-10 right-3"
          ></div>
          <div
            data-aos="fade-left"
            data-aos-delay="1000"
            className="w-6 h-6 rounded-full bg-sky-500 absolute bottom-20 right-2"
          ></div>
          <div
            data-aos="fade-left"
            data-aos-delay="1100"
            className="w-5 h-5 rounded-full bg-slate-200 absolute top-6 right-8"
          ></div>
          <div className="w-20 h-20 rounded-full bg-slate-950 absolute top-[20%] left-3"></div>
        </div>
      </div>

      <div
        data-aos="fade-right"
        data-aos-delay="2000"
        className="absolute hidden md:block bottom-32 left-4"
      >
        {/* needed for parallax */}
        <div className="parallax_css ">
          <div
            className="w-20 h-20 rounded-full shadow bg-gradient-to-r from-slate-800 via-blue-500 to-indigo-900 animate-pulse hover:animate-none bg-size-200 bg-pos-0 hover:bg-pos-100 transition-all"
            title="click me :)"
          ></div>
        </div>
      </div>
    </section>
  );
};
